import React, { useEffect, useState } from "react";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

export const Monitor = (props) => {

    const [tiempoInactivo, setTiempoInactivo] = useState(0);
    const [pause, setPause] = useState(false);
    const [mostrarModal, setMostrarModal] = useState(false);
    const { minutosExpirarSession } = props;


    useEffect(() => {
        const interval = !pause && setInterval(() => {
            setTiempoInactivo((tiempoInactivo) => tiempoInactivo + 1);
            verificar();
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [tiempoInactivo, pause]);

    const verificar = () => {
        if (tiempoInactivo >= (minutosExpirarSession * 60)) {
            setPause(true);
            setMostrarModal(true);
        }
    }

    const [MousePosition, setMousePosition] = useState({
        left: 0,
        top: 0
    });

    function handleMouseMove(ev) {
        setMousePosition({ left: ev.pageX, top: ev.pageY });
        setTiempoInactivo(0);
    };

    const cerrarSesion = () => {
        window.location = "/idsenube";
    }

    const footer = (
        <div>
            <Button label="Aceptar" icon="pi pi-check" onClick={cerrarSesion} />
        </div>
    );

    return (<div id="monitor" onMouseMove={(ev) => handleMouseMove(ev)}
        style={{ left: MousePosition.left, top: MousePosition.top }}>
         {/* { <h1>{tiempoInactivo} - {(minutosExpirarSession * 60)}</h1> } */}
        <div>
            {props.children}
        </div>

        <Dialog appendTo={document.body} header="Sesión caducada" visible={mostrarModal} style={{ width: '50vw' }}
            modal={true} closable={false} footer={footer}>
            Tu sesión ha terminado por inactividad de {minutosExpirarSession} minutos, tienes que volver a iniciar sesión
        </Dialog>
    </div>);
}